import {
  ApiGetHook,
  ApiMutateHook,
  useApiGet,
  useApiMutate,
} from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMethods } from "../models/ApiMethods";
import {
  SystemInfoBanner,
  UpsertSystemInfoBannerRequest,
} from "../models/SystemInfoBanner";

export function useCurrentSystemInfoBanner(): ApiGetHook<SystemInfoBanner | null> {
  return useApiGet<SystemInfoBanner | null>(
    ApiEndpoints.SystemInfoBannerCurrent,
    null,
    "system-info-banner-current"
  );
}

export function useSystemInfoBannerGet(): ApiGetHook<SystemInfoBanner> {
  return useApiGet<SystemInfoBanner>(
    ApiEndpoints.SystemInfoBanner,
    null,
    "system-info-banner"
  );
}

export function useUpdateSystemInfoBanner(): ApiMutateHook<
  SystemInfoBanner,
  UpsertSystemInfoBannerRequest
> {
  return useApiMutate<SystemInfoBanner, UpsertSystemInfoBannerRequest>(
    ApiEndpoints.SystemInfoBanner,
    ApiMethods.Put,
    null,
    null,
    ["system-info-banner", "system-info-banner-current"]
  );
}
